import { Anchor, Box, Divider, Flex, Image, Text } from '@mantine/core';
import { Sort } from '../../../../../backend/src/types.generated';
import { useFetchNewsFeedItemsQuery } from './graphql.generated';
import styles from './styles.module.css';

export const NewsAndArticles = () => {
	const { data, loading, error } = useFetchNewsFeedItemsQuery({
		variables: {
			pagination: { orderBy: { createdAt: Sort.Desc } },
		},
	});
	return (
		<Flex justify="center" direction="column" gap="md" px="lg" py="0" pb="lg">
			<Text size="lg" fw={900}>
				News and Articles
			</Text>
			{loading && <Text>Loading...</Text>}
			{error && <Text>Error: {error.message}</Text>}
			{data?.newsFeeds?.length === 0 && <Text>No news or articles found</Text>}
			{data?.newsFeeds?.map((article) => (
				<Flex key={article?.id} direction="column" gap="xs">
					<Flex align="flex-start" gap="md">
						<Flex>
							<Box className={styles.emptyImage}>
								{article?.imageUrl && (
									<Image src={article.imageUrl} alt={article.title} className={styles.image} />
								)}
							</Box>
						</Flex>
						<Flex direction="column" gap="xs">
							<Text size="md" fw={700}>
								{article?.title}
							</Text>
							<Text size="sm">{article?.description}</Text>
							{article?.linkUrl && <Anchor href={article?.linkUrl}>Read More</Anchor>}
						</Flex>
					</Flex>
					<Divider size={1} color="blue.0" />
				</Flex>
			))}
		</Flex>
	);
};
